import script from "./Notifications.vue?vue&type=script&setup=true&lang=js"
export * from "./Notifications.vue?vue&type=script&setup=true&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=ccceb89c&lang=scss&scoped=true"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccceb89c"]])

export default __exports__